import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSocial } from '../../context/socialProvider';
import { platformConfig } from '../../components/PlatformIcons';

// Fun, time-aware greeting remains for future use
function getGreeting() {
  const hour = new Date().getHours();
  if (hour < 4) return "Why are you up";
  if (hour < 6) return "Still dark out";
  if (hour < 8) return "Early bird gets the worm";
  if (hour < 10) return "Rise and shine";
  if (hour < 12) return "Good morning";
  if (hour < 14) return "Hope you had lunch";
  if (hour < 16) return "Early afternoon vibes";
  if (hour < 18) return "Good afternoon";
  if (hour < 20) return "Evening grind time";
  if (hour < 22) return "Good evening";
  if (hour < 23) return "Night owl mode";
  return "It's almost midnight... 👀";
}

const Dashboard = () => {
  const { currentSocial } = useSocial();
  const [isHovered, setIsHovered] = useState(false);
  
  // Platform info for future use
  const platformInfo = currentSocial?.provider 
    ? platformConfig[currentSocial.provider] 
    : null;

  return (
    <div className="bg-black min-h-screen-[96px] flex flex-col items-center pt-24 px-4">
      <div className="text-center max-w-md">
        {/* Builder smiley illustration */}
        <div className="mb-8 relative mx-auto w-48 h-48">
          {/* Main circle face */}
          <div className="w-48 h-48 rounded-full bg-neutral-700 mx-auto relative overflow-hidden">
            {/* Eyes */}
            <div className="absolute top-16 left-10 w-8 h-8 rounded-full bg-neutral-900"></div>
            <div className="absolute top-16 right-10 w-8 h-8 rounded-full bg-neutral-900"></div>
            
            {/* Smile */}
            <div className="absolute bottom-16 left-0 right-0 mx-auto w-24 h-12 border-b-4 border-neutral-900 rounded-full"></div>
            
            {/* Builder's hat */}
            <div className="absolute -top-2 left-0 right-0 mx-auto">
              <div className="w-56 h-14 bg-yellow-500 rounded-md"></div>
              <div className="w-32 h-10 bg-yellow-600 rounded-t-lg mx-auto -mt-10"></div>
            </div>
          </div>
        </div>
        
        <h1 
          className="text-4xl font-bold text-white mb-4"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          Coming soon!
        </h1>
        
        <p className="text-neutral-400 text-lg">
          We're building amazing analytics features for your account.
        </p>
        
        <div className={`mt-8 flex gap-2 justify-center transition-opacity duration-500 ${isHovered ? 'opacity-100' : 'opacity-0'}`}>
          <div className="w-3 h-3 bg-violet rounded-full animate-bounce"></div>
          <div className="w-3 h-3 bg-violet rounded-full animate-bounce delay-150"></div>
          <div className="w-3 h-3 bg-violet rounded-full animate-bounce delay-300"></div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;